<template>
  <div class="fixed-head" :style="styleOption">
    <div class="head-content">
      <div class="logo">
        <img src="static/logo.png" alt="" />
      </div>
      <div class="nav-bar">
        <router-link to="/" class="nav-link">首页</router-link>
        <div @mouseover="mouseOver" class="introduce">产品介绍
          <div class="product" v-show="isShow" @mouseleave="mouseLeave">
            <div :class="['item', checkIndex == 1 ? 'active' : '']" @click="check(1)">
              <router-link class="link" to="/introduce/scan">
                <img src="static/icon2.png" alt="">
                <span>扫码开票</span>
              </router-link>
            </div>
            <div :class="['item', checkIndex == 2 ? 'active' : '']" @click="check(2)">
              <router-link class="link" to="/introduce/quick">
                <img src="static/icon1.png" alt="">
                <span>立码开票</span>
              </router-link>
            </div>
            <div :class="['item', checkIndex == 3 ? 'active' : '']" @click="check(3)">
              <router-link class="link" to="/introduce/batch">
                <img src="static/icon3.png" alt="">
                <span>批量开票</span>
              </router-link>
            </div>
          </div>
        </div>
        <router-link to="/download" class="nav-link">税控软件</router-link>
        <!-- <router-link to="/download" class="nav-link">下载中心</router-link> -->
        <router-link to="/contact" class="nav-link">联系我们</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headCom",
  props:['styleOption'],
  data() {
    return {
      activeIndex: "/",
      isShow:false,
      checkIndex: 0
    };
  },
  computed: {},
  created() {
    let href = location.href;
    if(href.indexOf('scan') > 0){
      this.checkIndex = 1;
    } else if(href.indexOf('quick') > 0) {
      this.checkIndex = 2;
    }else if(href.indexOf('batch') > 0) {
      this.checkIndex = 3;
    } else {
      this.checkIndex = 0;
    }
  },
  methods: {
    // handleSelect(key, keyPath) {
    //   if (key === this.$route.path) {
    //     return;
    //   }
    //   // console.log(key, keyPath)
    //   this.$router.push({ path: key});
    // }
    mouseOver(){
      this.isShow = true;
     
    },
    mouseLeave(){
      this.isShow = false;
    },
    check(index){
      console.log(index)
      this.checkIndex = index;
    }
  }
};
</script>
<style scoped>
.fixed-head {
  /* position: fixed; */
  z-index: 998;
  top: 0;
  left: 0;
  /* margin-left: -550px; */
  width: 100%;
  height: 70px;
  /* background: #0A0B2A; */
}
.head-content {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo {
  width: 113px;
  height: 48px;
  margin-top: 10px;
}
.logo img {
  /* width: 100%; */
  height: 100%;
}
.nav-bar {
  display: flex;
  align-items: center;
}
.nav-bar .nav-link {
  margin-left: 80px;
  color: #fff;
  font-weight: bold;
  border-bottom: 2px solid transparent;
  padding: 10px 0;
  display: block;
}
.nav-bar .nav-link:hover,.nav-bar .introduce:hover{
  border-bottom: 2px solid #fff;
}
.nav-bar .introduce{
  position: relative;
  margin-left: 80px;
  color: #fff;
  font-weight: bold;
  border-bottom: 2px solid transparent;
  padding: 10px 0;
  display: block;
}

.introduce .product{
  width: 360px;
  height: 120px;
  position: absolute;
  bottom: -140px;
  left: -120px;
  display: flex;
  align-items: center;
}
.introduce .product .item{
  width: 120px;
  height: 120px;
  background: #0A0B2A;
  cursor: pointer;
}
.introduce .product .item .link{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.introduce .product .item:hover,.introduce .product .active{
  background: #1D1F43;
}
.introduce .product .item .link img{
  width: 45px;
  height: 45px;
}
.introduce .product .item .link span{
  color: #fff;
  font-weight: bold;
  margin-top: 15px;
}
/* /deep/.el-menu {
  background-color: transparent;
}
/deep/.el-menu.el-menu--horizontal {
  border: none;
}
/deep/.el-menu.el-menu--horizontal .el-menu-item {
  color: #ffffff;
}
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #ffffff;
}
/deep/ .el-menu--horizontal > .el-menu-item.is-active {
  border: none;
  background: transparent;
}
/deep/.el-menu--horizontal > .el-menu-item:hover,
/deep/.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent;
  border-bottom: 2px solid #ffffff !important;
}
/deep/.el-menu--popup .el-menu-item:hover {
  color: #b42d38;
}
/deep/.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  border-bottom: 2px solid #ffffff;
} */
</style>



// WEBPACK FOOTER //
// src/components/head.vue